import React from 'react'
import PropTypes from 'prop-types'

import {useIntl} from 'react-intl'
import {useStyleConfig, Button} from '@salesforce/retail-react-app/app/components/shared/ui'

/**
 * WeChatButton component renders a button styled for WeChat interactions.
 *
 * @param {Object} props - The component props.
 * @param {string} props.label - The text label for the button, also used for the aria-label.
 * @param {string} props.fontColor - The color of the button text.
 * @param {string} props.fontSize - The size of the button text.
 * @param {Function} props.onWeChatOpen - The function to call when the button is clicked.
 * @returns {JSX.Element} The rendered WeChat button component.
 */
const WeChatButton = ({label, fontColor, fontSize, onWeChatOpen}) => {
    const styles = useStyleConfig('Footer')
    const {formatMessage} = useIntl()

    return (
        <Button
            onClick={onWeChatOpen}
            {...styles.link}
            color={fontColor}
            fontSize={fontSize}
            display={'inline-block'}
            height={'fit-content'}
            padding={0}
            fontWeight={500}
            aria-label={formatMessage({
                defaultMessage: 'Open WeChat modal',
                id: 'wechat.button.aria_label'
            })}
            role="button"
            tabIndex={0}
        >
            {label}
        </Button>
    )
}

export default WeChatButton

WeChatButton.propTypes = {
    label: PropTypes.string.isRequired,
    fontColor: PropTypes.string,
    fontSize: PropTypes.string,
    onWeChatOpen: PropTypes.func.isRequired,
    isWeChatOpened: PropTypes.bool
}
